/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { WorkflowTemplateStepsControllerCreateMutationRequest, WorkflowTemplateStepsControllerCreateMutationResponse, WorkflowTemplateStepsControllerCreate400, WorkflowTemplateStepsControllerCreate401, WorkflowTemplateStepsControllerCreate403 } from "../../models/workflowsController/WorkflowTemplateStepsControllerCreate";

function getWorkflowTemplateStepsControllerCreateUrl() {
  const res = { method: 'POST', url: `/api/v1/workflow-template-steps` as const }  
  return res
}

/**
 * @summary Add a step to a workflow template
 * {@link /api/v1/workflow-template-steps}
 */
export async function workflowTemplateStepsControllerCreate(data?: WorkflowTemplateStepsControllerCreateMutationRequest, config: Partial<RequestConfig<WorkflowTemplateStepsControllerCreateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<WorkflowTemplateStepsControllerCreateMutationResponse, ResponseErrorConfig<WorkflowTemplateStepsControllerCreate400 | WorkflowTemplateStepsControllerCreate401 | WorkflowTemplateStepsControllerCreate403>, WorkflowTemplateStepsControllerCreateMutationRequest>({ method : "POST", url : getWorkflowTemplateStepsControllerCreateUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}